"use client";

import React, { useState } from "react";
import { Button } from "../button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../dialog";
import { Calendar } from "lucide-react";
import { useAuth } from "../../hooks/useAuth";

interface BookingModalProps {
  customerName?: string;
  itemLink?: string;
  isMobile?: boolean;
  className?: string;
}

const BookingModal = ({
  customerName,
  itemLink,
  isMobile = false,
  className,
}: BookingModalProps) => {
  const [open, setOpen] = useState(false);
  const { getAuthToken } = useAuth();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // Create dates
  const startDate = new Date();
  const endDate = new Date(Date.now() + 3600000); // 1 hour from now

  const googlePreFilledValues = {
    start: { dateTime: startDate.toISOString() },
    end: { dateTime: endDate.toISOString() },
    attendees: [
      { email: "miclainkeffeler@westtn.consulting" },
      { email: "charlie.keffeler@westtn.consulting" },
      { email: "leanne.york@westtn.consulting" },
      { email: "eliza.keffeler@westtn.consulting" },
      { email: "amanda.whitehorn@westtn.consulting" },
    ],
    summary: customerName
      ? `WTC <> ${customerName}: Meeting`
      : "WTC Meeting - TOPIC HERE",
    description: "",
  };

  const msftPreFilledValues = {
    start: { dateTime: startDate },
    end: { dateTime: endDate },
    attendees: [{ emailAddress: "charlie.keffeler@schooleymitchell.com" }],
    subject: customerName
      ? `SM <> ${customerName}: Meeting`
      : "SM Meeting - TOPIC HERE",
    content: "",
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          variant="outline"
          onClick={handleOpen}
          size={isMobile ? "sm" : "default"}
          className={className}
        >
          <Calendar className="h-4 w-4 mr-2" />
          Book a Meeting
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Select Calendar Platform</DialogTitle>
          <DialogDescription>
            Only use Microsoft for Schooley Events
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-4">
          {/* Google Calendar Option */}
          <div className="p-4 border rounded-lg">
            <h3 className="font-semibold mb-2">Google Calendar</h3>
            <p className="text-sm text-muted-foreground mb-3">
              Create a meeting in Google Calendar
            </p>
            <Button
              variant="outline"
              className="w-full"
              onClick={() => {
                // TODO: Implement Google Calendar integration
                console.log("Google Calendar booking");
              }}
            >
              Create Google Meeting
            </Button>
          </div>

          {/* Microsoft Calendar Option */}
          <div className="p-4 border rounded-lg">
            <h3 className="font-semibold mb-2">Microsoft Calendar</h3>
            <p className="text-sm text-muted-foreground mb-3">
              Create a meeting in Microsoft Calendar (Schooley Events)
            </p>
            <Button
              variant="outline"
              className="w-full"
              onClick={() => {
                // TODO: Implement Microsoft Calendar integration
                console.log("Microsoft Calendar booking");
              }}
            >
              Create Microsoft Meeting
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BookingModal;
